import { render, staticRenderFns } from "./modal-subscription-expired.vue?vue&type=template&id=3c6e540d&scoped=true&"
import script from "./modal-subscription-expired.vue?vue&type=script&lang=js&"
export * from "./modal-subscription-expired.vue?vue&type=script&lang=js&"
import style0 from "./modal-subscription-expired.vue?vue&type=style&index=0&id=3c6e540d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6e540d",
  null
  
)

/* custom blocks */
import block0 from "./modal-subscription-expired.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports